import React, {useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Image from 'react-bootstrap/Image';
import Spinner from 'react-bootstrap/Spinner';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import './App.css';
import axios from 'axios';
import {Col, Row} from "react-bootstrap";

const fetcher = axios.create({
    baseURL: 'https://api.coingecko.com/api/v3'
});

const App = () => {
    const [original, setOriginals] = useState([]);
    const [coins, setCoins] = useState([]);
    const [updated, setUpdated] = useState('');
    const [reference, setReference] = useState(null);
    const [selectedCoin, setSelectedCoin] = useState(null);

    useEffect(() => {
        if (coins.length === 0) {
            fetcher.get('/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=106&page=1&sparkline=false')
                .then(res => {
                    const data = res.data.filter(e => e.symbol !== 'usdt' && e.symbol !== 'usdc' && e.symbol !== 'dai'
                        && e.symbol !== 'busd' && e.symbol !== 'husd' && e.symbol !== 'tusd');
                    setCoins(data);
                    setOriginals(data);
                    console.log(data[0]);
                });
        }
    });

    const simulatePair = ({target}) => {
        const {value} = target;
        if (value === 'select...') {
            setCoins(original);
            setUpdated('');
            setReference(null);
            setSelectedCoin(null);
        } else {
            const [symbol, toSymbol] = value.split("/");
            const newCoins = [...original];
            const idx = original.findIndex(c => c.name === symbol);
            const refIdx = original.findIndex(c => c.name === toSymbol);
            const _ratio = original[refIdx].market_cap / original[idx].market_cap;
            newCoins[idx] = {
                ...newCoins[idx],
                current_price: original[idx].current_price * _ratio,
                market_cap: original[idx].market_cap * _ratio,
            };
            setSelectedCoin({before: original[idx], after: newCoins[idx]});
            setReference(original[refIdx]);
            setCoins(newCoins);
            setUpdated(symbol);
        }
    };

    const formatter = new Intl.NumberFormat('en-IN', {style: 'currency', currency: 'USD', minimumFractionDigits: 0});
    const format = num => formatter.format(num);

    function nFormatter(num, digits) {
        var si = [
            {value: 1, symbol: ""},
            {value: 1E3, symbol: "K"},
            {value: 1E6, symbol: "M"},
            {value: 1E9, symbol: "B"},
            {value: 1E12, symbol: "T"}
        ];
        var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var i;
        for (i = si.length - 1; i > 0; i--) {
            if (num >= si[i].value) {
                break;
            }
        }
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
    }

    const mcapFormat = num => nFormatter(num, 2)

    const increasePercentage = (before, after) => ((after - before) / before * 100).toFixed(0)

    return (
        <Container className="p-3">
            <h1>What if my coin 🚀 as high as?</h1>

            {coins.length === 0 && <div align={"center"} style={{marginTop: 150}}>
                <h3><Spinner animation={"border"} variant={"success"}/> Loading Top 100 <br/><br/>
                    <Image width="280" height="78"
                           src="https://static.coingecko.com/s/coingecko-logo-d13d6bcceddbb003f146b33c2f7e8193d72b93bb343d38e392897c3df3e78bdd.png"/>
                </h3>
            </div>}

            {reference && selectedCoin && <Card style={{width: '500px', margin: '50px auto'}}>
                <Card.Header as="h5" style={{backgroundColor: "#369", color: 'white', textAlign: 'center'}}>
                    {selectedCoin.before.name} ⇄ {reference.name}
                </Card.Header>
                <Card.Body>
                    <Row style={{textAlign: 'center'}}>
                        <Col><Image src={selectedCoin.before.image} roundedCircle width="100"/></Col>
                        <Col><Image src={reference.image} roundedCircle width="100"/></Col>
                    </Row>
                    <Card.Text style={{textAlign: 'center'}}><br/>
                        If <b style={{color: '#369'}}>{selectedCoin.before.name}</b> had the same market cap as <b
                            style={{color: '#963'}}>{reference.name} </b>
                        it would make it the
                        <b style={{color: '#369'}}> #{1 + original.findIndex(c => c.name === reference.name)}</b> crypto
                        after an increase of
                        <b style={{color: '#369'}}> {increasePercentage(selectedCoin.before.current_price, selectedCoin.after.current_price)}%</b>,
                        with a coin priced at
                        <b style={{color: '#369'}}> {format(selectedCoin.after.current_price)}</b>, and a total market
                        cap of
                        <b style={{color: '#369'}}> ${mcapFormat(reference.market_cap)}</b>.
                    </Card.Text>
                </Card.Body>
            </Card>}

            {coins.length > 0 && <Table striped bordered hover variant="light" style={{marginTop: 50}}>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Symbol</th>
                    <th>Price</th>
                    <th>Market Cap</th>
                    <th>ATL</th>
                    <th>ATH</th>
                    <th>As</th>
                </tr>
                </thead>
                <tbody>
                {coins.map((coin, idx) => {
                    const until = coins.slice(0, coins.findIndex(c => c.symbol === coin.symbol));
                    const highlighted = coin.name === updated;
                    return (<tr key={coin.name} style={{backgroundColor: highlighted && 'rgb(212, 237, 218)'}}>
                        <td>{idx + 1}</td>
                        <td><Image src={coin.image} width={'20em'} rounded/> {coin.name}</td>
                        <td align={"center"}>{coin.symbol.toUpperCase()}</td>
                        <td align={"right"}
                            style={{fontWeight: highlighted && 'bold'}}>
                            <div>
                                {format(coin.current_price)}<br/>
                                {highlighted ?
                                    <span>+{increasePercentage(selectedCoin.before.current_price, selectedCoin.after.current_price)}%</span>
                                    : <div style={{fontSize: "0.7em", top: 0}}><span
                                        style={{color: 'darkred'}}>{format(coin.low_24h)}</span> - <span
                                        style={{color: 'darkgreen'}}>{format(coin.high_24h)}</span></div>}
                            </div>
                        </td>
                        <td align={"right"}
                            style={{fontWeight: highlighted && 'bold'}}>${mcapFormat(coin.market_cap)}</td>
                        <td align={"right"}>{format(coin.atl)}</td>
                        <td align={"right"}>{format(coin.ath)}</td>
                        <td>{until.length > 0 ? <Form.Control as="select" onChange={simulatePair}>
                            <option value={"select..."}>Select...</option>
                            {until.map(c => <option key={c.name}
                                                    value={coin.name + "/" + c.name}>{c.symbol.toUpperCase()} - {c.name}</option>)}
                        </Form.Control> : <span/>}</td>
                    </tr>)
                })}
                </tbody>
            </Table>}

        </Container>
    );
};

export default App;
